// Loaded from frontend/.env at dev/build time (Vue CLI only reads env in project root)

function envString(name, fallback = '') {
  return String(process.env[name] || fallback).trim().replace(/^['"]|['"]$/g, '')
}

export const BOOKS_API_KEY = envString('VUE_APP_BOOKS_API_KEY')
export const booksApiUrl = envString('VUE_APP_BOOKS_API_URL', 'https://www.googleapis.com/books/v1/volumes')
export const imgBooksUrl = envString('VUE_APP_BOOKS_IMG_URL', 'https://books.google.com/books/content')

